// @flow
import { basePath } from '../config';

type Options = {};

const config = {
  mode: 'cors',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Content-Language': 'fr_FR'
  }
};

const configPOST = {
  ...config,
  method: 'POST'
};

const configGET = {
  ...config,
  method: 'GET'
};

class SearchAPI {
  static getData(service: string, options?: Options = {}) {
    return fetch(`${basePath}/${service}`, {
      ...configPOST,
      body: JSON.stringify(options)
    })
      .then(function(response) {
        return new Promise((resolve, reject) => {
          if (response.status === 200) {
            // Vérifier que la réponse est bien du JSON
            response.text().then(text => {
              try {
                const data = JSON.parse(text);
                resolve(data);
              } catch (jsonError) {
                console.error('JSON Parse Error:', jsonError);
                console.error('Response text:', text);
                reject(
                  new Error(
                    `Invalid JSON response: ${text.substring(0, 200)}...`
                  )
                );
              }
            });
          } else {
            // Log error response for debugging
            response
              .text()
              .then(text => {
                console.error(
                  'API Error:',
                  response.status,
                  text.substring(0, 200)
                );
                reject(new Error(`API Error ${response.status}`));
              })
              .catch(() => {
                reject(
                  new Error(
                    `API Error ${response.status}: ${response.statusText}`
                  )
                );
              });
          }
        });
      })
      .catch(error => {
        console.error('Network Error:', error);
        throw error;
      });
  }

  static getDocuments(options: Options) {
    return SearchAPI.getData('documents', options);
  }

  static getFacets(options: Options) {
    return SearchAPI.getData('facets', options);
  }

  static getTranslations(options: Options) {
    return SearchAPI.getData('i18n', options);
  }

  static getPermissions(urls: Array<string> = [], platformID: string = 'OB') {
    const params = new URLSearchParams();
    params.set('urls', urls.join(','));

    if (urls.join(',').includes('journals.openedition.org')) {
      platformID = 'OJ';
    }

    params.set('platformID', platformID);

    return fetch(`${basePath}/permissions?${params.toString()}`, {
      ...configGET
    }).then(function(response) {
      return new Promise((resolve, reject) => {
        if (response.status === 200) {
          resolve(response.json());
        } else {
          reject(response.statusText);
        }
      });
    });
  }
}

export default SearchAPI;



// WEBPACK FOOTER //
// ./src/library/SearchAPI.js